import { apiService } from '../../shared/services/apiService';
import { CustomerSubscription } from '../interfaces/customerSubscription';
import { PromoCodeInfo } from '../interfaces/promoCodeInfo';

type ApplyPromoCodeResponse = {
  subscriptions: CustomerSubscription[];
  promocode: PromoCodeInfo;
};

type GetSubscriptionsResponse = {
  subscriptions: CustomerSubscription[];
  promocode: PromoCodeInfo | null;
};

export const scanIqSubscriptionsService = {
  async getSubscriptions(entityId: number) {
    const response = await apiService.post<GetSubscriptionsResponse>(
      `/api/scan-iq/customer/subscriptions`,
      { entityId },
    );
    return response.data;
  },

  async applyPromoCode(entityId: number, promocode: string) {
    const response = await apiService.post<ApplyPromoCodeResponse>(
      `/api/scan-iq/customer/subscriptions/apply-promo`,
      { entityId, promocode },
    );

    return response.data;
  },
};
